var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNorway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0127C24.8366 32.0127 32 24.8493 32 16.0127C32 7.17614 24.8366 0.0126953 16 0.0126953C7.16344 0.0126953 0 7.17614 0 16.0127C0 24.8493 7.16344 32.0127 16 32.0127Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.550781 20.1864C1.47653 23.6214 3.51684 26.5985 6.26047 28.7066V20.1864H0.550781Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6084 31.9516C15.067 31.9911 15.5308 32.0125 15.9997 32.0125C23.3921 32.0125 29.6125 26.9987 31.4485 20.1864H14.6084V31.9516Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4485 11.8388C29.6125 5.02651 23.3921 0.0126953 15.9997 0.0126953C15.5308 0.0126953 15.067 0.0340703 14.6084 0.0735703V11.8388H31.4485Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26047 3.3186C3.51684 5.42673 1.47653 8.40379 0.550781 11.8387H6.26047V3.3186Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8646 13.9258H12.5218H12.5218V0.393036C11.0431 0.720911 9.64131 1.25235 8.34781 1.95816V13.9257V13.9257H0.135438C0.046375 14.6089 0 15.3054 0 16.0127C0 16.72 0.046375 17.4165 0.135438 18.0997H8.34775H8.34781V30.0672C9.64131 30.773 11.0431 31.3045 12.5218 31.6324V18.0999V18.0997H31.8646C31.9535 17.4165 32 16.72 32 16.0127C32 15.3054 31.9535 14.6089 31.8646 13.9258V13.9258Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0126953)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorway);
export default __webpack_public_path__ + "static/media/norway.61b26513.svg";
export { ForwardRef as ReactComponent };